<template>
    <div class="convention-section-title">
        <typo :id="id" :name="`cc-${type}`">
            <span ref="element" v-html="title" />
        </typo>
    </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    components: {},
    props: ["title", "type", "id"],
    mounted() {},
});
</script>

<style lang="sass">
=line
    display: block
    height: 1px
    background: $color-secondary
    content: ""
    flex-grow: 1

.convention-section-title

    .cc-h1
        text-transform: uppercase
        text-align: center
        background: $color-secondary
        color: white
        display: block
        margin-top: 50px
        margin-bottom: 20px
        padding: 5px 0

    .cc-h2
        display: block
        position: relative
        margin: 50px 0 30px 0
        padding-bottom: 10px
        &:before
            position: absolute
            width: 50px
            bottom: 0
            content: ""
            height: 1px
            background: $color-secondary

    .cc-h3
        position: relative
        display: block
        margin: 30px 0 15px 0

    .cc-h4
        position: relative
        display: block
        margin-top: 16px
        margin-bottom: 16px

    .cc-h5
        position: relative
        display: block
        margin: 30px 0 5px 0

    .cc-note-di
        font-style: italic
        font-weight: normal
</style>
